import $ from 'jquery';
import './scripts/common';
import onInitModulesInScope from './scripts/onInitModulesInScope';
import initModulesInScope from "@elements/init-modules-in-scope";
import * as thumbSlider from './scripts/thumbSlider';
import * as lightbox from './scripts/lightbox';
import * as colorHover from './scripts/colorHover';
import * as slider from '@elements/slider';
import * as productDetailSlider from './scripts/productDetailSlider';
import * as ajaxForm from '@elements/ajax-form';
import * as ajaxFormScroll from './scripts/ajaxFormScroll';
import * as threesixtyView from './scripts/threesixtyView';
import * as productDetail from './scripts/productDetail';
import * as productSlider from './scripts/productSlider';
import * as toggleOffscreen from './scripts/toggle-offscreen';
import * as ajaxCheck from './scripts/ajaxCheck';
import * as smoothScroll from '@elements/smooth-scroll';
import * as stickyAddToCartBtn from './scripts/stickyAddToCartBtn';
import * as stepView from './scripts/stepView';
import * as parsley from '@elements/parsley-bootstrap-validation';
import * as scrollableTabs from './scripts/scrollableTabs';
import * as countdown from './scripts/countdown';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = window['app'] || {
    debug: false,
};
window.app = app || {};
window.app.modules =  app.modules || {};

app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/
onInitModulesInScope(thumbSlider.initInScope);

onInitModulesInScope(lightbox.initInScope);

onInitModulesInScope(colorHover.initInScope);


let recommendationSliderOptions = {
    prevArrow:"<button type='button' class='slick-prev' aria-label='prev'><span class='icon icon-arrow-left'></span></button>",
    nextArrow:"<button type='button' class='slick-next' aria-label='next'><span class='icon icon-arrow-right'></span></button>",
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4
};

if (matchMedia('(max-width: 541px)').matches) {
    recommendationSliderOptions.slidesToShow = 1.2;
} else if (matchMedia('(max-width: 1199px)').matches) {
    recommendationSliderOptions.slidesToShow = 3;
}

onInitModulesInScope(slider.createInitInScope('.js-recommendation-slider', recommendationSliderOptions));


onInitModulesInScope(productDetailSlider.initInScope);

onInitModulesInScope(ajaxForm.initInScope);

onInitModulesInScope(ajaxFormScroll.initInScope);

onInitModulesInScope(threesixtyView.initInScope);

onInitModulesInScope(productDetail.initInScope);

onInitModulesInScope(productSlider.initInScope);

onInitModulesInScope(toggleOffscreen.initInScope);

onInitModulesInScope(ajaxCheck.initInScope);

if (matchMedia('(max-width: 767px)').matches) {
    let i = 0;
    let checkMobileAccordion = setInterval(function() {
        let count = i++;
        if ($('body').hasClass('ab-mobile-accordion')) {
            smoothScroll.init({
                offset: 55
            });
            clearInterval(checkMobileAccordion);
        }
        if( count > 4 ) {
            clearInterval(checkMobileAccordion);
            smoothScroll.init({
                offset: 15
            });
        }
    }, 1000);
} else {
    smoothScroll.init({
        offset: 15
    });
}

onInitModulesInScope(smoothScroll.initInScope);

onInitModulesInScope(stickyAddToCartBtn.initInScope);

onInitModulesInScope(stepView.initInScope);

onInitModulesInScope(parsley.initInScope);

onInitModulesInScope(scrollableTabs.initInScope);

onInitModulesInScope(countdown.initInScope);

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);
